module.exports = __webpack_public_path__ + "static/media/measure.b25b4d48.png";